import { Component, OnInit } from '@angular/core';
import { ModalType } from '@models';
import { ModalService } from '@services/modal.service';

@Component({
  selector: 'app-registry-hint-modal',
  templateUrl: './registry-hint-modal.component.html',
  styleUrls: ['./registry-hint-modal.component.scss'],
})
export class RegistryHintModalComponent implements OnInit {

  constructor(
    private readonly modalService: ModalService,
  ) { }

  ngOnInit() {
  }

  whereRegistryNumber() {
    this.modalService.show({
      type: ModalType.confirm,
      title: 'Onde encontrar seu número de matrícula',
      message: `Caso você não lembre o número de matrícula,
                basta ligar para a sua academia e informar seu CPF e nome completo para requisitá-lo.`,
    });
  }
}
